export * from './customer-data-form';
export * from './declaration-end';
export * from './insurer-fitter-page';
export * from './insurer-mobile-fitter-openings-page';
export * from './intervention';
export * from './side-summary';
export * from './sinister-data-form';
